import Link from "@components/Link/Link";
import StructuredData from "@components/StructuredData/StructuredData";
import styles from "./Breadcrumb.module.scss";

export interface BreadcrumbProps {
  slug: string;
  title: string;
  breadcrumbs?: CrumbProps[];
}

export interface CrumbProps {
  title: string;
  url: string | null;
}

const generateBreadcrumbSchema = (
  slug: string,
  title: string,
  breadcrumbs: CrumbProps[]
) => {
  const breadcrumbList = breadcrumbs.map((crumb, index) => ({
    "@type": "ListItem",
    position: index + 2,
    name: crumb.title,
    item: `${process.env.NEXT_PUBLIC_URL}/${crumb.url}`,
  }));

  return {
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: `${process.env.NEXT_PUBLIC_URL}`,
      },
      ...breadcrumbList,
      {
        "@type": "ListItem",
        position: breadcrumbList.length + 2,
        name: title,
        item: `${slug}`,
      },
    ],
  };
};

export const Breadcrumb = ({ slug, title, breadcrumbs }: BreadcrumbProps) => {
  return (
    <>
      <StructuredData
        id="BreadcrumbListSchema"
        schemaData={generateBreadcrumbSchema(slug, title, breadcrumbs)}
      />
      <div className={styles.breadcrumb}>
        <div className={styles.wrapper}>
          <ul className={styles["breadcrumb-links"]}>
            {slug !== "home" ? (
              <>
                <li>
                  <Link href="/">Home</Link>
                </li>
                {breadcrumbs?.map((crumb: CrumbProps, i) => {
                  if (!crumb.title) {
                    return null;
                  }
                  return (
                    <li
                      className="flex items-center"
                      key={`${crumb.title}${i}`}
                    >
                      <Link href={`/${crumb.url}`}>{crumb.title}</Link>
                    </li>
                  );
                })}
                <li className={styles["current-location"]}>{title}</li>
              </>
            ) : (
              <li>Home</li>
            )}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Breadcrumb;
